import * as React from 'react';
import * as classnames from 'classnames';
import Overview from 'lib/Overview';
import RuleHome from './rule-home';
import EditModal1 from './edit-modal-1';
import EditModal2 from './edit-modal-2';
import { MatchingRule, NavigationProps, MatchingBrandData } from 'lib/types';
import { ToastContainer, Toast } from '@salesforce/design-system-react';
import * as ReactDOM from 'react-dom';
import './matching-rules.css';
import { withBrandData } from 'lib/withBrand';

const dateOptions = {month: '2-digit', day: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'};

interface MatchingRuleProps extends NavigationProps {
	brandData: MatchingBrandData;
}

interface MatchingRulesState {
	rule?: MatchingRule;
	editing: boolean;
	modalScreen: 1 | 2;
	sources: MatchingRule[];
	toast: MatchingRule | false;
}

class MatchingRules extends React.Component<MatchingRuleProps, MatchingRulesState> {
	private toasts: Element;

	constructor (props: MatchingRuleProps) {
		super(props);
		this.state = {
			editing: false,
			modalScreen: 1,
			sources: props.brandData.rules,
			toast: false
		};
	}

	closeModal = () => {
		this.setState({ editing: false, modalScreen: 1});
	}

	editRule = (rule: MatchingRule) => {
		this.setState({ rule });
	}

	previewRule = (rule: MatchingRule) => {
		this.setState({
			rule,
			editing: true,
			modalScreen: 2
		});
	}

	nextModal = () => {
		this.setState({ modalScreen: 2});
	}

	saveModal = () => {
		this.closeModal();
		const selectedRule = this.state.rule as MatchingRule;
		const lastModified = new Date(Date.now()).toLocaleString('en-US', dateOptions);
		const openToast = () => { this.toasts.className = this.toasts.className + ' open'; };
		const closeToast = () => this.toasts.className = this.toasts.className.replace(' open', '');
		const activateRule = (rule: MatchingRule) => {
			rule.description = rule.description.replace('Exact First Name', 'Fuzzy First Name'); // Only happens on some brands
			rule.status = 'active';
			rule.lastModified = lastModified;
			return rule; 
		};
		const isActivatedRule = (rule: MatchingRule) => rule.id === selectedRule.id;
		const findAndActivateRule = (rule: MatchingRule) => isActivatedRule(rule) ? activateRule(rule) : rule;

		this.setState({ 
			rule: undefined,
			sources: this.state.sources.map(findAndActivateRule),
			toast: selectedRule
		});
		setTimeout(() => { openToast(); setTimeout(closeToast, 2000); }, 0);
	}

	renderModal() {
		if (!this.state.rule) { return null; }
		const { modalStep2 } = this.props.brandData;
		const { modalScreen, rule } = this.state;

		return (modalScreen === 1 ?
			<EditModal1 rule={rule} onClose={this.closeModal} onNext={this.nextModal} /> :
			(
				<EditModal2
					brand={modalStep2}
					rule={rule}
					onClose={this.closeModal}
					onSave={this.saveModal}
				/>
			)
		);
	}

	renderObject () {
		if (!this.state.rule) { return null; }

		return (
			<RuleHome
				editModal={this.state.editing ? this.renderModal() : null}
				editRule={() => this.setState({ editing: true })}
				navBack={() => this.setState({ rule: undefined })}
				rule={this.state.rule}
			/>
		);
	}

	renderOverview () {
		const { sources } = this.state;
		const { ruleClick } = this.props.brandData;
		const handleClick = ruleClick === 'edit' ? this.editRule : this.previewRule;

		return (
			<Overview
				buttonRight="New Rule"
				columns={[
					{ label: 'Name', property: 'name', handleClick, link: true },
					{ label: 'Status', property: 'status',
						activeStatus: 'active',
						statusLabels: { active: 'Active', inactive: 'Inactive' }
					},
					{ label: 'Description', property: 'description' },
					{ label: 'Last Modified', property: 'lastModified' }
				]}
				hasRowActions
				rows={sources}
				sortedBy="Name"
				title="Matching Rules"
			/>
		);
	}

	render () {
		const { rule, toast } = this.state;
		return (
			<div className={classnames('matching-rules', {'showing-rule': Boolean(rule)})}>
				<ToastContainer ref={(toasts: React.ReactInstance) => this.toasts = ReactDOM.findDOMNode(toasts) as Element}>
					{Boolean(toast) ?
						<Toast	
							labels={{ heading: `Matching rule "${toast && toast.name}" was saved and activated.`}}
							variant="success"
						/> :
						null
					}
				</ToastContainer>
				{this.state.rule ? this.renderObject() : this.renderOverview()}
			</div>
		);
	}
}

export default withBrandData('matching', MatchingRules);


// WEBPACK FOOTER //
// ./src/MatchingRules/index.tsx